import { render } from "./Block.vue?vue&type=template&id=5764556c"
import script from "./Block.vue?vue&type=script&lang=js"
export * from "./Block.vue?vue&type=script&lang=js"

import "./Block.vue?vue&type=style&index=0&id=5764556c&lang=css"
script.render = render

export default script